import { axiosRequest } from '../helpers/axios'

const setAvatar = (userId, payload) => {
  return axiosRequest('POST', `/users/${userId}/avatar`, payload, null)
}

export default setAvatar
